import { Flex, FlexProps } from '../../../../atoms';

export function OutletMain(props: FlexProps): JSX.Element {
  return (
    <Flex
      w="100%"
      flexDirection="column"
      flex={1}
      p="space_unit.x2"
      pb="space_unit.x8"
      {...props}
    />
  );
}
